<template>
    <el-dialog title="Neuer Sektor" :visible.sync="$parent.showFieldForm" width="300px">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-row>
                <el-col :span="24">
                    <el-form-item :class="[form.error ? 'is-error' : '' ]" label="Anzahl Einheiten" prop="number_of_panels">
                        <el-input
                            placeholder="Anzahl Einheiten"
                            @keyup.native="validateNumber(form.number_of_panels)"
                            v-model="form.number_of_panels"/>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm('form')">
                Bestätigen
                <i v-if="formSubmitted" class="el-icon-loading"></i>
            </el-button>
            <el-button @click="closeForm">Abbrechen</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import api from '../../../util/api';

    export default {
        name: 'SectorForm',
        data () {
            return {
                formLabelWidth: '120px',
                dialogFormVisible: false,
                formSubmitted: false,
                rules: {
                    number_of_panels: [
                        { required: true, message: 'Number required!', trigger: 'blur' },
                    ],
                },
                form: {
                    error: false,
                    number_of_panels: 0,
                },
            };
        },
        props: {
            formVisible: {
                type: Boolean,
                required: true,
            },
            submitFormCallback: {
                required: true,
                type: Function,
            },
        },
        methods: {
            closeForm () {
                this.$parent.showFieldForm = false;
            },
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        const url = `building/${this.$parent.building.id}/field/create`;
                        const postData = {
                            number_of_panels: this.form.number_of_panels,
                        };

                        this.formSubmitted = true;

                        api.post(url, postData).then((resp) => {
                            this.formSubmitted = false;
                            this.submitFormCallback(resp);
                            this.closeForm();
                        });
                    }
                });
            },
            validateNumber (num) {
                const pattern = new RegExp(/^(\d+)$/);
                this.form.error = !pattern.test(num);
            },
        },
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/fields/FieldForm.vue